import { render, staticRenderFns } from "./AppHelp.vue?vue&type=template&id=3e7e4a80&"
import script from "./AppHelp.vue?vue&type=script&lang=js&"
export * from "./AppHelp.vue?vue&type=script&lang=js&"
import style0 from "./AppHelp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports